import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'; //直接导入store对象
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/index/home/index.vue')
      },
      {
        path: 'companyProfile',
        name: 'companyProfile',
        component: () => import('@/views/index/companyProfile/index.vue')
      },
      {
        path: 'P&R',
        name: 'P&R',
        component: () => import('@/views/index/P&R/index.vue')
      },
      {
        path: 'contactUs',
        name: 'contactUs',
        component: () => import('@/views/index/contactUs/index.vue')
      },

      {
        path: 'publicAnnouncement',
        name: 'publicAnnouncement',
        component: () => import('@/views/index/publicAnnouncement/index.vue')
      },
      {
        path: 'announcementDetails',
        name: 'announcementDetails',
        component: () => import('@/views/index/announcementDetails/index.vue')
      },
      {
        path: 'PoliciesAndRegulations',
        name: 'PoliciesAndRegulations',
        component: () => import('@/views/index/PoliciesAndRegulations/index.vue')
      },
      {
        path: 'more',
        name: 'more',
        component: () => import('@/views/index/more/index.vue')
      }
    ]
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/registration',
    name: 'registration',
    meta: {
      keepAlive: true
    },
    component: () => import('@/views/registration/registration.vue')
  },
  {
    path: '/expertRegistration',
    name: 'expertRegistration',
    component: () => import('@/views/registration/expertRegistration.vue')
  },
  {
    path: '/personalCenter',
    name: 'personalCenter',
    // redirect: '/account',
    component: () => import('@/views/index/personalCenter/index.vue')
    // children: [
    //   {
    //     path: '/account',
    //     name: 'account',
    //     component: () => import('@/views/index/personalCenter/components/accountCom'),
    //   },
    //   {
    //     path: '/application',
    //     name: 'application',
    //     component: () => import('@/views/index/personalCenter/components/applicationCom'),
    //   },
    // ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: '',
  routes
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err)
}

router.beforeEach(async (to, from, next) => {
  if (to.path!=='/registration'&&to.path!=='/expertRegistration') {
    store.commit('CLEAR_DATA')

  }
  next()
})

// 全局路由后置守卫
router.afterEach((to, from) => {
  // console.log('跳转结束')
})
export default router
